/*
	Recargo automático (Cobros unificado, Etapa 2). El servidor manda el recargo DENTRO de su mensualidad
	(TuitionDTO.surcharge) y no como un mes más. Aquí lo que comparten Finanzas y el carrito.
*/

/** El recargo que el carrito tiene que cobrar junto con su mensualidad: pendiente, sin factura y sin abono. */
export const recargoEnCarrito = (tuition: any): any | null => {
	const s = tuition?.surcharge;
	if (!s || Number(s.statusId) !== 0 || Number(s.invoiceId || 0) !== 0 || Number(s.paid || 0) > 0.009 || Number(s.pending || 0) <= 0.009) return null;
	return s;
};

export const dinero = (n: number, simbolo: string): string =>
	(simbolo || "") + (Math.round((Number(n) || 0) * 100) / 100).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** "Pagó tarde · 12 días · sube a L440 el 31/10" (corto, para el renglón). */
export const recargoDetalle = (s: any, simbolo: string): string => {
	if (!s) return "";
	const partes: string[] = [];
	if (s.state === "eximido") partes.push("eximido");
	else if (s.state === "pagado") partes.push("pagado");
	else if (s.state === "detenido") partes.push("ya no crece");
	if (s.waived > 0 && s.state !== "eximido") partes.push("eximido " + dinero(s.waived, simbolo));
	if (s.next && s.next.date) partes.push("sube a " + dinero(s.next.amount, simbolo) + " el " + s.next.date.slice(8, 10) + "/" + s.next.date.slice(5, 7));
	return partes.join(" · ");
};
